import styled from "styled-components";
import camelCase from "lodash/camelCase";
import { useTranslation } from "react-i18next";
import { Box, Tabs, mainTheme } from "dash-ui";
import { useLocation, useNavigate } from "react-router-dom";

import { RoutesPath } from "flow-components/routes/routes";
import { getCurrentTabFromSearchParam } from "common/helpers";
import { stickyTopBarStyles } from "containers/properties/helpers/stickyTopBarStyles";

import { DEFAULT_API_TAB_KEY, ApiTabsKeys } from "./ApiTabs.constants";
import ApiUsersPage from "pages/api-management/ApiCompaniesPage/ApiCompaniesPage";
import ApiPluginUsersPage from "pages/api-management/ApiPluginUsersPage/ApiPluginUsersPage";
import ApiMetricsPage from "pages/api-management/ApiMetricsPage/ApiMetricsPage";

const TabsBox = styled(Box)<{ top?: number }>`
  border-top: 1px solid ${mainTheme.colors.n30};
  border-bottom: 1px solid ${mainTheme.colors.n30};
  ${stickyTopBarStyles}
`;

function ApiTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = getCurrentTabFromSearchParam(
    location.search
  ) as ApiTabsKeys;

  const activeTab = currentTab || DEFAULT_API_TAB_KEY;
  const { t: tCommonLabels } = useTranslation("common", {
    keyPrefix: "labels",
  });

  const tabsMap: Record<ApiTabsKeys, () => JSX.Element> = {
    [ApiTabsKeys.METRICS]: () => <ApiMetricsPage />,
    [ApiTabsKeys.COMPANIES]: () => <ApiUsersPage />,
    [ApiTabsKeys.PLUGIN_USERS]: () => <ApiPluginUsersPage />,
  };

  return (
    <>
      <TabsBox w="100%" pos="sticky" overflow="visible">
        <Tabs
          variation="secondary"
          tabs={Object.values(ApiTabsKeys).map((key) => ({
            key,
            label: tCommonLabels(camelCase(key)),
          }))}
          activeTab={activeTab}
          onClick={(key) => navigate(`${RoutesPath.APIManagement}?tab=${key}`)}
        />
      </TabsBox>
      <Box w="100%">{tabsMap[activeTab]() || null}</Box>
    </>
  );
}

export default ApiTabs;
